module.exports = __webpack_public_path__ + "static/android_paso_2-20d1b3e138aac50ed9248dbfd50d824b.png";